module.exports = __webpack_public_path__ + "img/guanbi.15711645.png";